var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exportSystemLog"},[_c('div',{staticClass:"content"},[_c('el-button',{staticStyle:{"margin-left":"20px"},attrs:{"type":"primary","disabled":!_vm.editable},on:{"click":_vm.exportFile}},[_vm._v(_vm._s(_vm.$t('diagnostics.export')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }